(function() {
  let canSubmit = false;

  let requiredNum = 0;
  let required = [];

  // Restricts input for the given textbox to the given inputFilter function.
  function setInputFilter(textbox, inputFilter, errMsg) {
    [ "input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop", "focusout" ].forEach(function(event) {
      if(textbox == null) return;
      textbox.addEventListener(event, function(e) {
        if (inputFilter(this.value)) {
          // Accepted value.
          if ([ "keydown", "mousedown", "focusout" ].indexOf(e.type) >= 0){
            this.classList.remove("input-error");
            this.setCustomValidity("");
          }
  
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        }
        else if (this.hasOwnProperty("oldValue")) {
          // Rejected value: restore the previous one.
          if(this.value !== '') {
            this.classList.add("input-error");
            this.setCustomValidity(errMsg);
            this.reportValidity();
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
          }
          if(this.value == ''){
            this.classList.remove("input-error");
            this.setCustomValidity("");
          }
        }
        else {
          // Rejected value: nothing to restore.
          this.value = "";
        }
      });
    });
  }

  setInputFilter(document.getElementById("starting-number-8-digits-max"), function(value) {
    return /^\d*$/.test(value); // Allow digits and '.' only, using a RegExp.
  }, "Only digits are allowed");
  setInputFilter(document.getElementById("prefix-4-char-max"), function(value) {
    return /^[a-zA-Z]+$/.test(value); // Allow digits and '.' only, using a RegExp.
  }, "Only Letters are allowed");

  const check_laser_text = function(value) {
    return /^[0-9A-Za-z .-]+$/.test(value);
  }
  setInputFilter(document.getElementById("laser-text-line-1-17-characters-max"), check_laser_text, "Only Letters, Numbers, Periods, and - are allowed");
  setInputFilter(document.getElementById("laser-text-line-2-17-characters-max"), check_laser_text, "Only Letters, Numbers, Periods, and - are allowed");
  
   const enable_submit = function() {
    document.querySelector('.product-form button[type="submit"]').disabled = false;
  }
  
  const disable_submit = function() {
    document.querySelector('.product-form button[type="submit"]').disabled = true;
  }

  const check_required = function(){
    let filledOut = 0;
    for(let i = 0; i< required.length; i++){
      if(required[i].type == "text" || required[i].type == "select"){
        let val = document.querySelector('[name="'+required[i].name+'"]').value
        if(val.trim() != ''){
          filledOut = filledOut + 1
        }
      } 
      if(required[i].type == "radio" || required[i].type == "checkbox"){
        let val = document.querySelector('[name="'+required[i].name+'"]').value;
        if(val){
          filledOut = filledOut + 1
        }
      }
      
    }
    if(filledOut == requiredNum) {
      canSubmit = true;
      enable_submit();
    } else {
      canSubmit = false;
      disable_submit();
    }
  }
  
  let ztReq = document.querySelectorAll('.zt-field')
  for(let i = 0; i< ztReq.length; i++){
    let req = ztReq[i].querySelector('.zt-field .required');
    if(req !== null) {
      if(req.getAttribute('type') == 'checkbox' || req.getAttribute('type') == 'radio'){
        req.addEventListener('click', check_required);
      }
      req.addEventListener('blur', check_required);
      req.addEventListener('keyup', check_required);
      req.addEventListener('change', check_required);
      requiredNum = requiredNum + 1;
      required.push({type: req.getAttribute('type'), name: req.getAttribute('name')})
    }
  }


  const isValidNumberField = function (value, min, step) {
    if (typeof value !== 'number' || typeof min !== 'number' || typeof step !== 'number') {
      return false;
    }
    if (value < min) return false;
    // Check if (value - min) is a multiple of step
    return ((value - min) / step) % 1 === 0;
  }
  
  const check_qty = function(e) {
    let val = e.target.value;
    let min = e.target.min;
    let step = e.target.step;
    let valid = isValidNumberField(parseInt(val), parseInt(min), parseInt(step))
    if(valid == true) {
      enable_pay();
    } else {
      setTimeout(function() {
        disable_pay();
      }, 250)
    }
  }

  const disable_pay = function(){
    document.querySelector('shopify-accelerated-checkout').setAttribute('disabled', 'disabled')
    document.querySelector('.buy-buttons button[type="submit"]').setAttribute('disabled', 'disabled')
  }

  const enable_pay = function(){
    document.querySelector('shopify-accelerated-checkout').removeAttribute('disabled')
    document.querySelector('.buy-buttons button[type="submit"]').removeAttribute('disabled')
  }

  document.querySelector('.quantity__input').addEventListener('input', check_qty);

  
  document.addEventListener('DOMContentLoaded', function(){
    check_required();
  }, false);

 
  

  const zt_submit = function(event) {
    if(canSubmit == false) {

      event.preventDefault();
      return false;
    }
  }

  const show_toggle = function() {
    this.insertAdjacentHTML("beforeend", `<div class='zt-tooltip'>${decodeURIComponent(this.dataset.tool).replaceAll("+",' ')}</div>`);
  }
  const remove_toggle = function() {
    document.querySelector('.zt-tooltip').remove()
  }

  
  const toggle_field = function() {
    let toggle = document.querySelector(`div[data-toggle="${this.getAttribute('id')}"]`);
    if(toggle) {
        if(toggle.classList.contains('show-field')) {
          toggle.classList.remove('show-field')
          if(document.querySelector(`div[data-toggle="${this.getAttribute('id')}"] input[type="text"]`)){
            document.querySelector(`div[data-toggle="${this.getAttribute('id')}"] input[type="text"]`).value = '';
          }
          if(document.querySelector(`div[data-toggle="${this.getAttribute('id')}"] input[type="number"]`)){
            document.querySelector(`div[data-toggle="${this.getAttribute('id')}"] input[type="number"]`).value = '';
          }
        
      } else {
        toggle.classList.add('show-field')
      }
      
    }
  }
  
  let toggles = document.querySelectorAll('.toggle-field');
  for(let i = 0; i< toggles.length; i++){
    toggles[i].addEventListener('click', toggle_field)
  }

  let toolTip = document.querySelectorAll('.tool-tip');
  for(let i = 0; i< toolTip.length; i++){
    toolTip[i].addEventListener('mouseenter', show_toggle)
  }
  for(let i = 0; i< toolTip.length; i++){
    toolTip[i].addEventListener('mouseleave', remove_toggle)
  }

    document.addEventListener('DOMContentLoaded', () => {
  var elementExist2 = document.querySelector('#shopify-block-ANHkwMWlISk9iNktIb__hulk_discounts_offer_table_block_HmKB48');
          if (elementExist2) {

            elementExist2.classList.add('im-still-loading')
           }
})
  
  window.addEventListener('load', () => {
    let CurrentvarID = document.querySelector('input[name="id"]').value;
    let currProdObj = JSON.parse(JSON.stringify(tierprod))
    var tid = setInterval(timer, 100);
    var elementExist = null;
    function timer() {
      var elementExist = document.querySelectorAll('.hulkapps-volume-discount-tiers');
      if (elementExist.length == 1) {
          
         functionToLoad();
       }
      
      
    }

    const functionToLoad = function(){
    
      clearInterval(tid);
    
      add_savings_column();
            const myEvent = new CustomEvent('zipHulkAdded', { detail: { data: 'success' } });
            document.querySelector('.subtotal-info__piece').dispatchEvent(myEvent);
      
     
    
    }
    
    const add_savings_column = function(){
        var elementExist2 = document.querySelector('#shopify-block-ANHkwMWlISk9iNktIb__hulk_discounts_offer_table_block_HmKB48');
          
       CurrentvarID = document.querySelector('input[name="id"]').value
      let currentVar = currProdObj.variants; 
      let variant = currentVar.filter(function(item){
        return item.id  == CurrentvarID;
      })
      const table = document.querySelector('.hulkapps-table')
      if(table) {
        let oPrice = 0;
        if(variant.length > 0){
          oPrice = variant[0].price
        }
        const tr = table.querySelector("thead tr");
        const allHeaders = table.querySelectorAll("th");
        let alreadyDone = false;
        allHeaders.forEach((el) => {
          if(el.innerText == "$/Piece"){
            alreadyDone = true;
          }
        })
      if( alreadyDone == false) {
// Create a `th` with the provided column nam
        const th = document.createElement("th");
        th.innerText = 'Savings';
        
    
        allHeaders[1].innerText= "$/Piece"
        // Insert the `th` at appropriate location
        let insert = 1; //Which column it will be after
        tr.insertBefore(th, allHeaders[insert]);
    
        // Fill body rows with empty `td` elements
        const tbody = table.querySelector("tbody");
        var newRow = table.insertRow(table.rows.length);
        var row = table.insertRow(1);
        var cell1= row.insertCell(0);
      var cell2= row.insertCell(1);
      var cell3= row.insertCell(2);
        let row2Range = tbody.querySelectorAll('tr')[1].querySelectorAll('td')[0].innerText.split('-')
      if(row2Range.length > 0){ 
        cell1.innerHTML = "1 to " + (parseInt(row2Range[0]) - 1);
      }
      cell2.innerHTML = "--";
      cell3.innerHTML = '$'+ (oPrice /100).toFixed(2);


        Array.from(tbody.children).forEach(function(row,index) {
          const emptyTd = document.createElement("td");
          let currentTR =  tbody.querySelectorAll('tr')[index].querySelectorAll('td')
          if(index == 0) {
            // emptyTd.innerText = '--'
            // oPrice = currentTR[1].querySelector('.money').innerText.replace('$','');
            let qArray;
            if(currentTR[0].innerText.includes(' to ')){
             qArray = currentTR[0].innerText.split(' to ')
            } else {
             qArray = currentTR[0].innerText.split('-')
            }
            if(typeof qArray[1] == 'undefined') {
              qArray[1] = 99999999999999999;
            }
            discountArray.push({"low":qArray[0], "high":qArray[1], "price":(oPrice / 100)})
          } else {
            //(New Price - Original Price) / Original Price x 100
            if( typeof currentTR[1] !== 'undefined') {
               let newValue = (oPrice / 100) - parseFloat(currentTR[1].querySelector('.money').innerText.replace('$',''));
            newValue = newValue.toFixed(2);
              let qArray;
              if(currentTR[0].innerText.includes(' to ')){
               qArray = currentTR[0].innerText.split(' to ')
              } else {
               qArray = currentTR[0].innerText.split('-')
              }
              if(typeof qArray[1] == 'undefined') {
                qArray[1] = 99999999999999999;
              }
            currentTR[0].innerText = currentTR[0].innerText.replace('-',' to ');
            discountArray.push({"low":qArray[0], "high":qArray[1], "price":newValue})
            currentTR[1].innerText = '$'+newValue;
            let oPriceCents = oPrice/100;
            let nPrice = ((parseFloat(newValue) - parseFloat(oPriceCents)) / oPriceCents) * 100;
            emptyTd.innerText = parseInt(Math.abs(nPrice)) + '%'
          row.insertBefore(emptyTd, row.children[insert])
            }
           
          }
        })
        let qty = document.querySelector('input[name="quantity"]').value
        tier_pricing(qty)
        
      }
        setTimeout(function(){
         var elementExist2 = document.querySelector('#shopify-block-ANHkwMWlISk9iNktIb__hulk_discounts_offer_table_block_HmKB48');
          if (elementExist2) {
             elementExist2.classList.remove('im-still-loading')
           }
        }, 300)
         
      }
    }

    document.addEventListener('input change', function (event) {
    });

    document.addEventListener('variant:change', function (event) {
      var elementExist2 = document.querySelector('#shopify-block-ANHkwMWlISk9iNktIb__hulk_discounts_offer_table_block_HmKB48');
      if (elementExist2) {

            elementExist2.classList.add('im-still-loading')
           }
      setTimeout(function(){
        add_savings_column()
      }, 250)
    });
    document.addEventListener('ajaxProduct:added', function (event) {
      var elementExist2 = document.querySelector('#shopify-block-ANHkwMWlISk9iNktIb__hulk_discounts_offer_table_block_HmKB48');
      if (elementExist2) {

            elementExist2.classList.add('im-still-loading')
           }
       setTimeout(function(){
        add_savings_column()
      }, 250)
    });
    let barcodeSelector = document.querySelectorAll('input[name="properties[barcode]"]');
if (barcodeSelector) {
barcodeSelector.forEach(radio => {
  radio.addEventListener('change', function() {
    setTimeout(function(){
        add_savings_column()
      }, 250)
  });
});


}


   });

  
})();
document.addEventListener('DOMContentLoaded', function() {
  
  const forbiddenSkus = ["650093", "650123", "650153", "650183", "650102", "650103"];

  const truckSealNoBarcodeSKUs = ["650102", "650103"];

  const forbiddenBarcode = "Code 128 (+10%)";
  const alertMessage = "Unfortunately, barcodes are not available on Green seals because they don't show up clearly. Please choose another color.";
  const truckSealAlertMessage = "Unfortunately, barcodes are not available on Blue or Green truck seals because they don't show up clearly. Please choose another color.";

  function checkConflict() {
    
    const idInput = document.querySelector('input[name="id"]');
    if (!idInput) return; 
    
    const currentVariantId = parseInt(idInput.value);

    if (typeof tierprod !== 'undefined' && tierprod.variants) {
      
      const currentVariant = tierprod.variants.find(function(variant) {
        return variant.id === currentVariantId;
      });

      if (currentVariant && forbiddenSkus.indexOf(currentVariant.sku) > -1) {

         const barcodeInput = document.querySelector('input[name="properties[barcode]"][value="' + forbiddenBarcode + '"]:checked');

         if (barcodeInput) {
           const message = truckSealNoBarcodeSKUs.indexOf(currentVariant.sku) > -1
             ? truckSealAlertMessage
             : alertMessage;
           alert(message);

           const noneOption = document.querySelector('input[name="properties[barcode]"][value="None"]');
           if (noneOption) {
             noneOption.click();
           }
         }
      }
    }
  }

  document.addEventListener('change', checkConflict);
});